import GroupDetailsContainer from './GroupDetailsContainer';

export default GroupDetailsContainer;
